import { cn } from '@/lib/utils';

type Props = {
  className?: string;
  compact?: boolean;
};

/**
 * Typographic brand mark. Keeps the cross-section feel of the main Talbert
 * wordmark but rendered in-app for crisp scaling and themeability.
 */
export function BrandMark({ className, compact }: Props) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      {/* Monogram — the "T" inside a thin architectural square */}
      <div className="relative h-10 w-10 shrink-0 border border-brass-400/60 rounded-sm">
        <div className="absolute inset-[3px] border border-brass-400/20" />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="font-display text-lg font-semibold text-brass-300 leading-none translate-y-px">
            T
          </span>
        </div>
      </div>

      {!compact && (
        <div className="leading-tight">
          <div className="font-display text-[15px] text-text tracking-tight">
            Talbert <span className="text-brass-300">Architectural</span>
          </div>
          <div className="kicker text-[0.6rem] mt-0.5">
            Admin Portal · Est. 1950s
          </div>
        </div>
      )}
    </div>
  );
}
